import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { AuthService } from './auth.service';

@Injectable()
export class HttpService {
  constructor(private http: Http, private auth: AuthService) {}

  private createAuthorizationHeader(token: string): Headers {
    const headers = new Headers();
    headers.append('Authorization', 'Bearer ' + token);
    return headers;
  }

  async get(url: string) {
    const token = await this.auth.getIdToken();

    return this.http.get(
      url, {
      headers: this.createAuthorizationHeader(token)
    }).map(resp => {
      return resp.text();
    });
  }

  private handleError(error: any) {
    const errMsg = (error.message) ? error.message :
    error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
 }

  post(url: string, data: any) {
    const _this = this;

    return this.auth.getIdToken().then(function(token) {
      return _this.http.post(
        url, data, {
        headers: _this.createAuthorizationHeader(token)
      });
    });
  }

  put(url: string, data: any) {
    const _this = this;

    return this.auth.getIdToken().then(function(token) {
      return _this.http.put(
        url, data, {
        headers: _this.createAuthorizationHeader(token)
      });
    });
  }

  delete(url: string) {
    const _this = this;

    return this.auth.getIdToken().then(function(token) {
      return _this.http.delete(
        url, {
        headers: _this.createAuthorizationHeader(token)
      });
    });
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/http.service.ts